module.exports = __webpack_public_path__ + "img/kmap@3x.cec82ee0.png";